// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__5Tjs1","newExpiryDate":"styles_newExpiryDate__2Y95m","footer":"styles_footer__1vzng"};